import React, { useState } from 'react';

import { theme } from 'inpock-ui-react';
import CSS from 'csstype';

import { Icon } from '@/components';

import * as S from './styled';

export interface AccordionProps {
  header?: React.ReactElement;
  headerBgColor?: theme.ColorAlias;
  headerType?: 'default' | 'custom';
  children: React.ReactElement | React.ReactElement[] | string;
  open?: boolean;
  sx?: CSS.Properties;
  removeBorder?: boolean;
  firstRow?: React.ReactNode;
  secondRow?: React.ReactNode;
}

export function Accordion(props: AccordionProps) {
  const [open, setOpen] = useState(props.open || false);

  return (
    <S.Container style={props.sx}>
      <S.Header
        onClick={() => {
          setOpen(!open);
        }}
        headerBgColor={props.headerBgColor}
        open={props.open}
        removeBorder={props.removeBorder}
        headerType={props.headerType}
      >
        <S.ChildrenScope>
          {props.firstRow}
          <S.IconScope>
            <Icon icon={open ? 'ArrowUpLight' : 'ArrowDownLight'} size={16} color="#343434" />
          </S.IconScope>
        </S.ChildrenScope>
        <S.ChildrenScope>{props.secondRow}</S.ChildrenScope>
      </S.Header>
      <S.Body open={open}>{props.children}</S.Body>
    </S.Container>
  );
}
